<template>
  <div class="processing" :class="{'show': processing, 'ocrLoading': ocrLoading}">
    <div class="loading-box">
      <div class="ball-clip-rotate-pulse">
        <div></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'processing',
  props: ['processing', 'ocrLoading'],
  created: function () {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
.processing
  position absolute
  display none
  width 100%
  height 100%
  top 0px
  left 0px
  flex-direction column
  justify-content center
  align-items center
  z-index 1000
  &.show, &.ocrLoading
    display flex
  .loading-box
    width 60px
    height 60px
    margin-bottom 60px
    .ball-clip-rotate-pulse
      position relative
      width 100%
      height 100%
      border-radius 6px
      background-color rgba(0,0,0,0.3)
      div
        animation-fill-mode both
        width 22px
        height 22px
        position absolute
        top 50%
        left 50%
        margin-top -15px
        margin-left -15px
        border-radius 100%
        background transparent
        border 4px solid
        border-color #fff #fff #fff transparent
        animation process-rotate .7s 0s ease infinite
        animation-duration .7s
@keyframes process-rotate
  0%
    transform rotate(0deg)
  100%
    transform rotate(360deg)
</style>



// WEBPACK FOOTER //
// src/components/Et/Processing.vue